<template>
    <div class="first" ref="first">
        <div class="video">
            <video id="video" autoplay loop muted>
                <source src="/static/video/Weleda.mp4" type="video/mp4">
                <source src="/static/video/Weleda.ogg" type="video/ogg">
            </video>
            <div class="mask-video"></div>
        </div>
        <div class="pare-el">
            <div class="center animation1">
                <h2 class="head">
                    МОЁ ДРУГОЕ ЛЕТО
                </h2>
            </div>
            <div class="center animation2">
                <span class="desc">
                    Профессиональная сноубордистка и&nbsp;путешественница Оля Смешливая вместе с&nbsp;натуральной косметикой Weleda приглашают в&nbsp;удивительное приключение по&nbsp;красивейшим местам Европы.
                    Узнайте, как получить новый опыт, зарядиться энергией природы и&nbsp;насладиться свежим горным воздухом.
                </span>
            </div>
            <div class="center animation3">
                <route-item :to="'/main'" class="next" :element="'main'" @click.native="gaEvents('main','click','go down')"></route-item>
            </div>
        </div>
        <Form :showForm="showForm" @closeForm="close"></Form>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap';
    import Form from '@/components/common/Form';
    import Helpers from '@/tools/Helpers';

    export default {
        name: 'first',
        components:{
          Form
        },
        data() {
            return {
                showForm: true
            }
        },
        methods: {
            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },

            close() {
                this.showForm = false
            }
        },
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// first.vue?c260fb08